import { FC, useState, useRef, memo, useLayoutEffect } from 'react'
import { Table, TableProps } from 'antd'
import { useWindowSize } from '@/hooks/screen'
import styles from './index.module.scss'

const ShTable: FC<TableProps<any> & { bottomY?: number }> = props => {
  const { bottomY = 10, ...restProps } = props
  const [scrollY, setScrollY] = useState(0)
  const ref = useRef<any>(null)
  const windowSize = useWindowSize()

  useLayoutEffect(() => {
    const tableBody = ref.current?.querySelector?.('.sh-table-tbody')
    const { y = 0 } = tableBody?.getBoundingClientRect?.() ?? {}
    setScrollY(windowSize[1] - bottomY - y)
  }, [windowSize[1]])

  return <Table {...restProps} scroll={{ y: scrollY }} ref={ref} className={styles.container} />
}

export default memo(ShTable)
